import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';

const API_URL = environment.referenceTableQueryApi.replace('odata', 'api');

@Injectable({
  providedIn: 'root'
})
export class HelpTopicQueryService {
  constructor(private httpClient: HttpClient) {}

  get(domain: string, key: string): Observable<any> {
    return this.httpClient.get(
      `${API_URL}/HelpTopic?context=portal&domain=${domain}&key=${key}`
    );
  }
}
